module.exports = __webpack_public_path__ + "img/7-text.a0d785c9.png";